import React, { Component } from 'react';
import $ from 'jquery';
import * as Reqst from '../../../utils/Reqst';
import Sanitize from '../../../utils/Sanitize';
import { notify } from 'react-notify-toast';
import { Row, Col } from 'react-bootstrap';

class Edit extends Component {
	constructor(props) {
		super(props);
		this.state = {
			loginId: Sanitize.getData('labUser_id'),
			companyId: Sanitize.getData('labUser_clientid'),
			masterId: Sanitize.getData('labUser_masterid'),
			saveText: 'UPDATE VACANCY',
			isRedirect: false,
			showLoader: false,
			editData: this.props.editData,
			deptList: []
		}

		this.handleFormSubmit = this.handleFormSubmit.bind(this);
		this.onCheckChange = this.onCheckChange.bind(this);
	}

	handleFormSubmit(e) {
		e.preventDefault();
		this.setState({ showLoader: true, saveText: 'Updating..' });
		var formData = Sanitize.objectifyForm($("#frmAdd").serializeArray());
		Reqst.axPost('vacancy/updateVacancy', { token: Reqst.Token(formData) }).then(res => {
			if (res['data'].status == '1') {
				notify.show(res['data'].msg, 'success');
				this.setState({ showLoader: false, saveText: 'UPDATE VACANCY' });
				if (this.props.afterFinish) this.props.afterFinish();
			}
			else {
				notify.show(res['data'].msg, 'error');
				this.setState({ showLoader: false, saveText: 'UPDATE VACANCY' });
			}
		});
	}

	getData(field) {
		var l = this.state.editData;
		return l[field];
	}

	setData(field, e) {
		var l = this.state.editData;
		l[field] = e.target.value;
		this.setState({ editData: l });
	}

	componentDidMount() {
		this.loadDepartments();
	}

	loadDepartments() {
		this.setState({ showLoader: true });
		var token = Reqst.TimeStamp();
		Reqst.axGet('postcategory/getactivecategories/' + this.state.masterId + '/' + this.state.companyId + '/' + token).then(res => {
			if (res['data'].status == '1') {
				this.setState({ deptList: res['data'].data });
			}
			else {
				notify.show(res['data'].msg, 'error');
				//	this.setState({showLoader:false});	
			}
		});
	}

	onCheckChange(e) {
		if (e.target.checked) {
			$("#answer").show();
			$("#i__check").val('1');
		}
		else {
			$("#answer").hide();
			$("#i__check").val('0');
		}
	}


	render() {	

		return (
			<div>
				<form action="" method="post" encType="multipart/form-data" id="frmAdd" onSubmit={this.handleFormSubmit} >
					<input type="hidden" name="i__id" value={this.getData('id')} />
					<input type="hidden" name="i__lid" value={this.state.loginId} />
					<input type="hidden" name="i__company" value={this.state.companyId} />
					<input type="hidden" name="i__master" value={this.state.masterId} />
					<Row>
						<Col md={12} >
							<label>Category<span className="text-danger">*</span></label>
							<select name="i__cat" id="i__cat" className="form-control input-sm" value={this.getData('post_category')} onChange={this.setData.bind(this,'post_category')} required >
								<option value="">Select Category</option>
								{this.state.deptList.map((item, i) =>
									<option value={item.id} >{item.categoryname}</option>
								)}
							</select>
						</Col>
					</Row><br />
					<Row>
						<Col md={12} >
							<label>No of Vacancies<span className="text-danger">*</span></label>
							<input type="text" name="i__vacant" id="i__vacant" className="form-control input-sm"  value={this.getData('total_vacant')} onChange={this.setData.bind(this,'total_vacant')} required/>
						</Col>
					</Row><br />
					<Row>
						<Col md={1} style={{ padding: "0px 10px 0px 15px" }}>
							<input type="checkbox" name="i__check" id="i__check" defaultChecked={this.getData('gender') !='' ? 'checked' :''} value={this.getData('gender')} onChange={this.setData.bind(this,'gender')} className="form-control input-sm" onChange={this.onCheckChange} />
						</Col>
						<Col md={3} style={{ padding: "0px" }}>
							<label style={{ paddingTop: "5px" }}>Gender (optional)</label>
						</Col>
					</Row><br/>
					<Row id="answer">
						<Col md={6} >
							<label>No of Vacancy(Male)</label>
							<input type="text" name="i__male" id="i__male" className="form-control input-sm" value={this.getData('male_vacant')} onChange={this.setData.bind(this,'male_vacant')}/>
						</Col>
						<Col md={6} >
							<label>No of Vacancy(Female)</label>
							<input type="text" name="i__female" id="i__female" className="form-control input-sm" value={this.getData('female_vacant')} onChange={this.setData.bind(this,'female_vacant')}/>
						</Col>
					</Row><br />
					<Row>
						<Col md={12} >
							<br />
							<div className="text-right" >
								<button type="submit" className="btn btn-info btn-sm btn-success_2" disabled={this.state.saveText != 'UPDATE VACANCY'} >
									<i className="fa fa-check"></i> {this.state.saveText}
								</button>
							</div>
						</Col>
					</Row>
				</form>
			</div>
		);
	}

}
export default Edit;